import { useParams } from '@tanstack/react-router'
import { ClientsManagment } from './ClientsManagment'
import { SingleClientPage } from './SingleClientPage'
import { Paths } from '@/routes/paths'
import { CreateClientPage } from './CreateClientPage'

export const ClientsCnt = () => {
  const params = useParams({ strict: false }) as { clientId?: string }

  if (params.clientId) {
    return <SingleClientPage clientId={params.clientId} />
  }

  if (location.href.includes(Paths.Management.NewClient)) {
    return <CreateClientPage />
  }

  return <ClientsManagment />
}
